import React from 'react'
import useCustomerServicePageConfig from '../hooks/use-page-config'
import CustomerServiceLayoutDefault from '../layout/default'
import CSHeader from '../partials/header'
import CMSContent from '../../../components/cms-content'

const CustomerServiceCmsContentPage = () => {
    const pageConfig = useCustomerServicePageConfig()
    const {id, content, showTitle, name, description} = pageConfig
    const {body, ...rest} = content

    return (
        <CustomerServiceLayoutDefault maxWidth={'100%'} px={{base: 4, lg: '6.5rem', xl: 0}}>
            {showTitle && <CSHeader headline={name} subline={description} />}
            <CMSContent data-testid="content-page" id={id} content={{...rest, c_body: body}} />
        </CustomerServiceLayoutDefault>
    )
}

export default CustomerServiceCmsContentPage
